export type ValidationError = string | string[] | undefined;
export type ValidationErrors<T> = { [P in keyof T]?: ValidationError };

export function hasValidationErrors<T>(validationErrors: T): boolean {
  // Check for presence of at least one property with value that is not undefined.
  return (Object.keys(validationErrors as any) as Array<keyof T>).some(x => validationErrors[x] !== undefined);
}
